import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import * as _ from 'lodash';

import { BaseRoutingPageComponent } from 'shared/base/_base-routing-page.component';
import { LoaderComponent } from 'shared/loader/loader.component';
import { PermissionsService } from 'shared/permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'sd-global-page',
  templateUrl: 'global-page.component.html',
  styleUrls: ['global-page.component.scss'],
})
export class GlobalPageComponent extends BaseRoutingPageComponent implements OnInit {
  @ViewChild('loaderGlobal', {static: false}) loader: LoaderComponent | void;

  pagesMenuData: any;
  model: any = {
    title: '',
    color: '',
    withSearch: false
  };
  page: string = '';
  showSidedrawer: boolean = true; // use this field to show sidedrawer

  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    protected permissionsService: PermissionsService,
  ) {
    super(router);
  }

  onRouteChange(event: NavigationEnd) {
    const data: any = _.get(this.route.snapshot, 'children[0].data');
    if (!data) {
      return;
    }
    const { page, menu } = data;
    if (page.link !== 'global-brand-information') { this.startLoading(); }
    this.page = page.link;
    if (!page.withSearch) { page.withSearch = false; }
    Object.assign(this.model, page);
    this.applyPermissions(_.forEach(menu, (item: any) => item.visible = true));
    this.pagesMenuData = menu;
    // todo: add here listening to the component refresh
    _.delay(() => {
      this.stopLoading();
    }, 1000);
  }

  applyPermissions(menu: any) {
    return _.map(menu, (menuItem: any) => {
      if (menuItem.allow) {
          menuItem.visible = this.permissionsService.hasPermission(menuItem.allow);
          return menuItem;
      }
    });
  }

  // private
  private startLoading() {
    if (!this.loader) {
      return;
    }
    this.loader.show();
  }

  private stopLoading() {
    if (!this.loader) {
      return;
    }
    this.loader.hide();
  }
}
